var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        value: _vm.value,
        fullscreen: "",
        persistent: "",
        "no-click-animation": "",
        "hide-overlay": "",
        transition: "fade-transition",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "news-notice",
          attrs: {
            role: "alertdialog",
            "aria-modal": "true",
            "aria-labelledby": "news-notice-title",
          },
        },
        [
          _c("div", { staticClass: "news-notice__content" }, [
            _c(
              "button",
              {
                staticClass: "news-notice__bell",
                attrs: {
                  type: "button",
                  disabled: _vm.marking,
                  "aria-label": "Darme por enterado",
                  title: "Darme por enterado",
                },
                on: {
                  click: function ($event) {
                    return _vm.$emit("read")
                  },
                },
              },
              [
                _c("v-icon", { attrs: { size: "48", color: "white" } }, [
                  _vm._v("mdi-bell-ring-outline"),
                ]),
                _c("span", { staticClass: "news-notice__count" }, [
                  _vm._v(_vm._s(_vm.count > 99 ? "99+" : _vm.count)),
                ]),
              ],
              1
            ),
            _c("div", [
              _c(
                "h1",
                {
                  staticClass: "news-notice__title",
                  attrs: { id: "news-notice-title" },
                },
                [_vm._v("Hay novedades")]
              ),
              _c("p", { staticClass: "news-notice__subtitle" }, [
                _vm._v(
                  _vm._s(
                    _vm.count == 1
                      ? "Se publicó una novedad para vos."
                      : "Se publicaron " + _vm.count + " novedades para vos."
                  )
                ),
              ]),
            ]),
            _vm.latest.length > 0
              ? _c(
                  "ul",
                  { staticClass: "news-notice__list" },
                  [
                    _vm._l(_vm.latest, function (item) {
                      return _c("li", { key: item.id }, [
                        _vm._v(_vm._s(item.title)),
                      ])
                    }),
                    _vm.count > _vm.latest.length
                      ? _c("li", { staticClass: "news-notice__more" }, [
                          _vm._v(
                            "y " +
                              _vm._s(_vm.count - _vm.latest.length) +
                              " más"
                          ),
                        ])
                      : _vm._e(),
                  ],
                  2
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "news-notice__actions" },
              [
                _c(
                  "v-btn",
                  {
                    attrs: {
                      color: "primary",
                      depressed: "",
                      disabled: _vm.marking,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("open")
                      },
                    },
                  },
                  [_vm._v("Ver novedades")]
                ),
                _c(
                  "v-btn",
                  {
                    attrs: { text: "", loading: _vm.marking },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("read")
                      },
                    },
                  },
                  [_vm._v("Ya me enteré")]
                ),
              ],
              1
            ),
            _c("p", { staticClass: "news-notice__help" }, [
              _vm._v(
                "Tocá la campana para darte por enterado o entrá a Novedades. Siempre vas a poder volver a leerlas."
              ),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }